/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint react/jsx-one-expression-per-line: 0 */

import React from "react";
import styled from "styled-components";
import { Col, Row } from "react-bootstrap";

import {
  Carousel,
  Footer,
  NamedHeader,
  PageIntroKnaifel,
  SidesKnaifel,
  Spacer,
  Text,
  TopImage,
} from "../../../lib";

const { PUBLIC_URL } = process.env;

const Cover = styled.img`
  border: 1px solid #000;
  width: 50%;
`;

const Frame = styled.iframe`
  border: none;
  height: 450px;
  width: 100%;
`;

const Links = styled.div`
  position: sticky;
  top: 0px;
`;

const StyledTopImage = styled(TopImage)`
  margin-top: 30px;
`;

const Music: React.FC = () => (
  <>
    <NamedHeader name="музыка" />

    <PageIntroKnaifel author="knaifel" name="music" />

    <Spacer size={10} />

    <Carousel
      autoHeight
      slides={[{ url: `${PUBLIC_URL}/assets/images/knaifel/music/top.jpg` }]}
    />

    <Spacer size={10} />

    <SidesKnaifel hide="music">
      <Row>
        <Col lg={{ span: 8 }} sm={{ span: 8 }} xs={{ span: 8 }}>
          <Frame
            frameBorder="0"
            height="450"
            src="https://music.yandex.ru/iframe/#album/25676665"
            // style="border:none;width:100%;height:450px;"
            title="Yandex"
            width="100%"
          >
            Слушайте{" "}
            <a href="https://music.yandex.ru/album/19561139">
              Три степени свободы. Музыка кино СССР. (1) Альфред Шнитке
            </a>{" "}
            —{" "}
            <a href="https://music.yandex.ru/artist/3255058">
              Государственный симфонический оркестр кинематографии СССР
            </a>{" "}
            на Яндекс.Музыке
          </Frame>
        </Col>

        <Col lg={{ span: 4 }} sm={{ span: 4 }} xs={{ span: 4 }}>
          <Links>
            <Text size={24}>
              <a href="#" rel="noreferrer" target="_blank">
                VK Музыка
              </a>
              <br />
              <a href="#" rel="noreferrer" target="_blank">
                МТС Музыка
              </a>
              <br />
              <a href="#" rel="noreferrer" target="_blank">
                Apple Music
              </a>
              <br />
              <a href="#" rel="noreferrer" target="_blank">
                Spotify
              </a>
              <br />
            </Text>
          </Links>

          <Spacer size={10} />

          <a
            href="https://planeta.ru/campaigns/olegkaravaychuk"
            rel="noreferrer"
            target="_blank"
          >
            <Cover
              src={`${PUBLIC_URL}/assets/images/knaifel/music/cover.jpg`}
            />
          </a>
          <Spacer size={2} />
          <a href="https://planeta.ru/campaigns/olegkaravaychuk">
            <Text family="sans" size={18}>
              LP: предзаказ
            </Text>
          </a>
        </Col>
      </Row>
    </SidesKnaifel>

    <Spacer size={140} />

    <Footer />
  </>
);

export default Music;
